/*eslint no-unused-vars: "off"*/
import React from 'react';
import moment from 'moment-timezone';

class DataTable {

  CompletedReportList = (self) => {
    const CompletedColumns = [
      {
        title: 'Acc Number',
        dataIndex: 'acc_number',
        key: 'acc_number',
        render: (text, record) => (<span className="type">{record.customer? record.customer.account_number : ''}</span>)
      },
      {
        title: 'Customer Name',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (<span className="type">{record.customer? record.customer.first_name+' '+record.customer.last_name : ''}</span>)
      },
      {
        title: 'Address (Service)',
        dataIndex: 'address',
        key: 'address',
        render: (text, record) => (<span className="type">{record.service && record.service.service_order ? record.service.service_order.service_address.formatted_address : ''}</span>)
      },
      {
        title: 'Phone Number',
        dataIndex: 'service__service_order__phone_numbers__phone',
        sorter: true,
        showSorterTooltip: false,
        key: 'phone_number',
        render: (text, record) => (<span className="type">{record.primary_phone ? '+1'+record.primary_phone : ''}</span>)
      },
      {
        title: 'Email Address',
        dataIndex: 'customer__email',
        sorter: true,
        showSorterTooltip: false,
        key: 'email',
        render: (text, record) => (<span className="type">{record.customer? record.customer.email : ''}</span>)
      },
      {
        title: 'Service Type',
        dataIndex: 'service_type',
        key: 'service_type',
        render: (text, record) => (<span className="type">{record.service && record.service.service_order ? record.service.service_order.service_type.charAt(0).toUpperCase() + record.service.service_order.service_type.slice(1) : ''}</span>)
      },
      {
        title: 'Schedule Service',
        dataIndex: 'schedule_service',
        key: 'schedule_service',
        render: (text, record) => (<span className="type" style={{ "color": '#5AB220' }}>{record.service ? record.service.status.charAt(0).toUpperCase() + record.service.status.slice(1) : ''}</span>)
      },
      {
        title: 'Date of next Service',
        dataIndex: 'date_of_next_service',
        key: 'date_of_next_service',
        render: (text, record) => (<span className="type">{record.service ? moment(record.service.scheduled_time).format('MMM DD, YYYY') : ''}</span>)
      },
    ]
    return CompletedColumns
  }


  CancledReportList = (self) => {
    const CancledColumns = [
      {
        title: 'Acc Number',
        dataIndex: 'acc_number',
        key: 'acc_number',
        render: (text, record) => (<span className="type">{record.customer? record.customer.account_number : ''}</span>)
      },
      {
        title: 'Customer Name',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (<span className="type">{record.customer? record.customer.first_name+' '+record.customer.last_name : ''}</span>)
      },
      {
        title: 'Address (Service)',
        dataIndex: 'address',
        key: 'address',
        render: (text, record) => (<span className="type">{record.service  && record.service.service_order? record.service.service_order.service_address.formatted_address : ''}</span>)
      },
      {
        title: 'Phone Number',
        dataIndex: 'service__service_order__phone_numbers__phone',
        key: 'phone_number',
        sorter: true,
        showSorterTooltip: false,
        render: (text, record) => (<span className="type">{record.primary_phone ? '+1'+record.primary_phone : ''}</span>)
      },
      {
        title: 'Email Address',
        dataIndex: 'customer__email',
        key: 'email',
        sorter: true,
        showSorterTooltip: false,
        render: (text, record) => (<span className="type">{record.customer? record.customer.email : ''}</span>)
      },
      {
        title: 'Service Type',
        dataIndex: 'service_type',
        key: 'service_type',
        render: (text, record) => (<span className="type">{record.service && record.service.service_order ? record.service.service_order.service_type.charAt(0).toUpperCase() + record.service.service_order.service_type.slice(1) : ''}</span>)
        
      },
      {
        title: 'Reason',
        dataIndex: 'reason',
        key: 'reason',
        render: (text, record) => (<span className="type">{record.reason ? record.reason : ''}</span>)
      },
      {
        title: 'Schedule Service',
        dataIndex: 'schedule_service',
        key: 'schedule_service',
        render: (text, record) => (<span className="type" style={{ "color": '#5AB220' }}>Cancelled</span>)
      },
      {
        title: 'Date of next Service',
        dataIndex: 'date_of_next_service',
        key: 'date_of_next_service',
        render: (text, record) => (<span className="type">{record.service ? moment(record.service.scheduled_time).format('MMM DD, YYYY') : ''}</span>)
      },
    ]
    return CancledColumns
  }



  MissedReportList = (self) => {
    const MissedColumns = [
      {
        title: 'Acc Number',
        dataIndex: 'acc_number',
        key: 'acc_number',
        render: (text, record) => (<span className="type">{record.customer? record.customer.account_number : ''}</span>)
      },
      {
        title: 'Customer Name',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (<span className="type">{record.customer? record.customer.first_name+' '+record.customer.last_name : ''}</span>)
      },
      {
        title: 'Address (Service)',
        dataIndex: 'address',
        key: 'address',
        render: (text, record) => (<span className="type">{record.service && record.service.service_order ? record.service.service_order.service_address.formatted_address : ''}</span>)

      },
      {
        title: 'Phone Number',
        dataIndex: 'service__service_order__phone_numbers__phone',
        key: 'phone_number',
        sorter: true,
        showSorterTooltip: false,
        render: (text, record) => (<span className="type">{record.primary_phone ? '+1'+record.primary_phone : ''}</span>)

      },
      {
        title: 'Email Address',
        dataIndex: 'customer__email',
        key: 'email',
        sorter: true,
        showSorterTooltip: false,
        render: (text, record) => (<span className="type">{record.customer? record.customer.email : ''}</span>)
      },
      {
        title: 'Service Type',
        dataIndex: 'service_type',
        key: 'service_type',
        render: (text, record) => (<span className="type">{record.service && record.service.service_order ? record.service.service_order.service_type.charAt(0).toUpperCase() + record.service.service_order.service_type.slice(1) : ''}</span>)
      },
      {
        title: 'Reason',
        dataIndex: 'reason',
        key: 'reason',
        // render: (text, record) => (<span className="type">{text}</span>)
        render: (text, record) => (<span className="type">{record.reason ? record.reason : ''}</span>)

      },
      {
        title: 'Schedule Service',
        dataIndex: 'schedule_service',
        key: 'schedule_service',
        render: (text, record) => (record.service.status !== "schedule" ? <u  onClick={()=>{self.closeRescheduleDrawer(true)
          self.updateRescheduleData(record)}} style={{ "color": '#E02020' }}><span className="type" >Reschedule</span></u> : <span className="type" style={{ "color": '#5AB220' }}>Scheduled</span>)
      },
      {
        title: 'Date of next Service',
        dataIndex: 'date_of_next_service',
        key: 'date_of_next_service',
        render: (text, record) => (<span className="type">{record.service ? moment(record.service.scheduled_time).format('MMM DD, YYYY') : ''}</span>)
      },
    ]
    return MissedColumns
  }
}
export default new DataTable();